if (!window.__qtyStepperInit) {
  window.__qtyStepperInit = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qty-decrement], [data-qty-increment]');
    if (!button) return;

    const wrapper = button.closest('.\\#product-qty-selector-stepper');
    const input = wrapper && wrapper.querySelector('[data-input]');
    if (!input) return;

    const step = Number(input.step) || 1;
    const min = input.min !== '' ? Number(input.min) : 1;
    const max = input.max !== '' ? Number(input.max) : Infinity;
    const current = Number(input.value) || min;

    const next =
      button.hasAttribute('data-qty-increment') ? current + step : current - step;

    input.value = Math.min(max, Math.max(min, next));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}
